import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface Authorities {
  id: string;
  name: string;
  email: string;
  phoneNumber: string;
}

export interface AgencyAuthoritiesState {
  data: Authorities[] | null;
  loading: boolean;
  error: string | null;
}

export const agencyAuthoritiesSliceState: AgencyAuthoritiesState = {
  data: null,
  loading: false,
  error: null,
};

const agencyAuthoritiesSlice = createSlice({
  name: 'agencyAuthorities',
  initialState: agencyAuthoritiesSliceState,
  reducers: {
    fetchAgencyAuthoritiesRequest: (state, action: PayloadAction<string>) => {
      state.loading = true;
      state.error = null;
    },
    fetchAgencyAuthoritiesSuccess: (
      state,
      action: PayloadAction<Authorities[]>
    ) => {
      state.data = action.payload;
      state.loading = false;
    },
    fetchAgencyAuthoritiesFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  fetchAgencyAuthoritiesRequest,
  fetchAgencyAuthoritiesSuccess,
  fetchAgencyAuthoritiesFailure,
} = agencyAuthoritiesSlice.actions;

export default agencyAuthoritiesSlice.reducer;
